import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

const TimeLeft = ({ targetEpoch }) => {
    const [timeLeft, setTimeLeft] = useState('00:00');
    const { i18n } = useTranslation();
    const minLetter = i18n.language === 'ru' ? 'м' : 'm';
    const secLetter = i18n.language === 'ru' ? 'с' : 's';

    useEffect(() => {
        const update = () => {
        const now = Date.now();
        const diff = Math.max(targetEpoch - now, 0);
        const minutes = Math.floor(diff / 60000);
        const seconds = Math.floor((diff % 60000) / 1000);

        
        setTimeLeft(` ${String(minutes).padStart(2, '0')}${minLetter}:${String(seconds).padStart(2, '0')}${secLetter}`);
        };

        update(); // Initial update
        const interval = setInterval(update, 1000); // Update every second

        return () => clearInterval(interval); // Cleanup on unmount
    }, [targetEpoch]);

    return timeLeft;
};

export default TimeLeft;